function initializeOrDestroySwiper(swiperSelector) {
  const multicolumnList = document.querySelector(swiperSelector);
  
  // Ensure the element exists before manipulating it
  if (!multicolumnList) return;

  // Add the grid-layout class first for desktop or larger
  multicolumnList.classList.add("grid-layout");

  // Always initialize Swiper, regardless of the screen size
  if (typeof swiperPartners === 'undefined') {
      swiperPartners = new Swiper(swiperSelector, {
          slidesPerView: window.innerWidth <= 767 ? 3 : 5,  // Show 3 slides on mobile, 5 on desktop
          spaceBetween: 42,
          loop: true,  // Always loop
          autoplay: {
              delay: 3000,  // Autoplay with a delay of 3 seconds
              disableOnInteraction: false,  // Keep autoplay after user interaction
          },
          navigation: {
              nextEl: ".swiper-button-next.partners",
              prevEl: ".swiper-button-prev.partners",
          },
          watchOverflow: true, // Handle overflow issues if fewer slides
          touchMoveStopPropagation: true,
          touchEventsTarget: 'container',
          breakpoints: {
              0: {
                  slidesPerView: 3,  // Mobile view: 3 slides
                  spaceBetween: 10,
              },
              768: {
                  slidesPerView: 5,  // Desktop view: 5 slides
                  spaceBetween: 24,
              },
          },
          on: {
              init: function() {
                  // Remove the grid-layout class when Swiper is initialized
                  multicolumnList.classList.remove("grid-layout");
              },
          },
      });
  }

  // Destroy Swiper and restore grid layout on screen resize for desktop
  if (window.innerWidth > 767 && typeof swiperPartners !== 'undefined') {
      swiperPartners.destroy(true, true);
      swiperPartners = undefined;
      multicolumnList.classList.add("grid-layout");
  }
}

  
// Function to initialize or destroy Swiper based on viewport size
function initializeSwiper(swiperSelector, nextElSelector, prevElSelector) {
    // Check if the Swiper instance already exists
      swiperObj = new Swiper(swiperSelector, {
        slidesPerView: 1.3,
        spaceBetween: 24,
        breakpoints: {
          560: {
            slidesPerView: 3.2,
            spaceBetween: 24,
          },
          992: {
            slidesPerView: 3.2,
            spaceBetween: 24,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 24,
          }
        },
        navigation: {
          nextEl: nextElSelector,
          prevEl: prevElSelector,
        },
      });

    return swiperObj;
  }


//   Testimonials

function openPopup(videoType, videoSrc, mimeType) {
    const videoPopup = document.getElementById('videoPopup');
    const popupVideoContainer = document.getElementById('popupVideoContainer');

    if (videoType === 'video') {
      popupVideoContainer.innerHTML = `
        <video controls autoplay>
          <source src="${videoSrc}" type="${mimeType}">
          Your browser does not support the video tag.
        </video>
      `;
    } else if (videoType === 'youtube') {
      var videoId = videoSrc.split('v=')[1] || src.split('/').pop();
      videoId = videoId.split('?')[0]; // Ensure to strip any query parameters
      videoSrc = 'https://www.youtube.com/embed/' + videoId;

      popupVideoContainer.innerHTML = `
        <iframe width="100%" height="400" src="${videoSrc}" frameborder="0" allowfullscreen></iframe>
      `;
    }

    videoPopup.style.display = 'flex';
  }

  function closePopup() {
    const videoPopup = document.getElementById('videoPopup');
    videoPopup.style.display = 'none';
    document.getElementById('popupVideoContainer').innerHTML = ''; // Clear video content when closed
  }

  // Close popup when clicking outside of the popup content
  window.onclick = function (event) {
    const videoPopup = document.getElementById('videoPopup');
    if (event.target === videoPopup) {
      closePopup();
    }
  };



  function openPopup(type, src) {
    var popup = document.getElementById('videoPopup');
    var container = document.getElementById('popupVideoContainer');

    if (type === 'video') {
      container.innerHTML = '<video controls src="' + src + '" autoplay></video>';
    } else if (type === 'youtube') {
      var videoId = src.split('v=')[1] || src.split('/').pop();
      videoId = videoId.split('?')[0]; // Ensure to strip any query parameters
      container.innerHTML =
        '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
        videoId +
        '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    }

    popup.style.display = 'flex';
  }
document.addEventListener('DOMContentLoaded', function () {

  function setEqualHeightPrice() {
    const prices = document.querySelectorAll('.cma-hot-deal_custom .card-information .price');
    if (!prices.length) {
        console.warn("No prices found in .cma-hot-deal_custom .card-information .price.");
        return;
    }

    let maxHeight = 0;

    // Reset any previously set height
    prices.forEach((price) => {
        price.style.height = 'auto';
    });

    // Find the tallest price
    prices.forEach((price) => {
        const priceHeight = price.offsetHeight;
        if (priceHeight > maxHeight) {
            maxHeight = priceHeight;
        }
    });

    // Set all prices to the tallest height
    prices.forEach((price) => {
        price.style.height = `${maxHeight}px`;
    });
}


  function setEqualHeight() {
      const headings = document.querySelectorAll('.cma-hot-deal_custom .card__heading');
      if (!headings.length) {
          console.warn("No headings found in .cma-hot-deal_custom .card__heading.");
          return;
      }

      let maxHeight = 0;

      // Reset any previously set height
      headings.forEach((heading) => {
          heading.style.height = 'auto';
      });

      // Find the tallest heading
      headings.forEach((heading) => {
          const headingHeight = heading.offsetHeight;
          if (headingHeight > maxHeight) {
              maxHeight = headingHeight;
          }
      });

      // Set all headings to the tallest height
      headings.forEach((heading) => {
          heading.style.height = `${maxHeight}px`;
      });
      setEqualHeightPrice();
  }

  // Run the function on page load
  setEqualHeight();

  // Optionally run the function on window resize to adjust heights
  window.addEventListener('resize', setEqualHeight);
// Select all "Show More" buttons and containers
const showMoreButtons = document.querySelectorAll('#showMoreBtn span');
const productContainers = document.querySelectorAll('.cma-hot-deals');

// Loop through each button and container to add data attributes
showMoreButtons.forEach((showMoreBtn, index) => {
  const productContainer = productContainers[index];

  // Skip if there's no corresponding container
  if (!productContainer) return;

  // Set data-index attribute to link each button with its container
  showMoreBtn.setAttribute('data-index', index);
  productContainer.setAttribute('data-index', index);

  // Remove any previously attached event listener to avoid duplicates
  showMoreBtn.replaceWith(showMoreBtn.cloneNode(true)); // Remove existing listeners
  const newButton = document.querySelectorAll('#showMoreBtn span')[index]; // Re-query after cloning

  // Add event listener to toggle corresponding container
  newButton.addEventListener('click', function () {
    console.log(`Button with index ${index} clicked`); // Verify the click event

    // Find the container with the same data-index as the clicked button
    const targetContainer = document.querySelector(`.cma-hot-deals[data-index="${index}"]`);

    if (targetContainer.classList.contains('show-more')) {
      targetContainer.classList.remove('show-more');
      newButton.textContent = 'Load More';
    } else {
      targetContainer.classList.add('show-more');
      newButton.textContent = 'Load Less';

      // Recalculate equal heights after showing more items
      setTimeout(setEqualHeight, 100); // Ensure the new elements are fully rendered
    }
  });
});


});
